import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Configuration } from '@app/models/config.model';
import { ConfigService } from '@rockwell-automation-inc/service';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
@Injectable()
export class RequestIdInterceptor implements HttpInterceptor {
  private readonly configService = inject<ConfigService<Configuration>>(ConfigService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (!this.configService.config.isApiCall(req.url)) {
      return next.handle(req);
    }

    const newReq = req.clone({
      headers: req.headers.set('x-req-id', uuidv4()),
    });
    return next.handle(newReq);
  }
}
